module.exports = {
      id: "kishoralo-usage",
      viewBox: "0 0 512 209.434",
      url: "/" + "svg-sprite-f1921bf4f6bf5e98a1b5d71e857b44f0.svg#kishoralo",
      toString: function () {
        return this.url;
      }
    }